import { useEffect, useState } from "react";
import { companyID, getEmployeeLocalDetails } from "../../auth";
import { encrypt } from "../../utils/crypto";

export const useSidebarData = () => {
  const [loginEmployeeId, setLoginEmployeeId] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [onboardingStatus, setOnboardingStatus] = useState(false);

  useEffect(() => {
    const employeeId = localStorage.getItem("employeeID");
    const company_id = companyID();
    const employeeDetails = getEmployeeLocalDetails();
    setOnboardingStatus(employeeDetails?.onboarding_status ?? "PENDING");
    const encryptedEmployeeId = encrypt(employeeId);
    setLoginEmployeeId(encryptedEmployeeId);
    setCompanyId(company_id);
  }, []);

  const onboardingPending = [
    {
      tittle: "MAIN",
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: "Onboarding",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/onboarding",
          icon: "la la-user-plus",
        },
      ],
    },
  ];

  const allMenus = [
    {
      tittle: "MAIN",
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: "Dashboard",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/employee-dashboard",
          icon: "la la-dashcube",
        },
        {
          menuValue: "Calendar",
          hasSubRoute: false,
          showSubRoute: false,
          route: "/events",
          icon: "la la-calendar",
        },
      ],
    },
    {
      tittle: "Me",
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: "Me",
          hasSubRoute: true,
          showSubRoute: false,
          route: "#",
          icon: "la la-user",
          subMenus: [
            {
              menuValue: "Holidays",
              route: "/holidays",
            },
            {
              menuValue: "Leave Dashboard",
              route: `/leave-dashboard/${loginEmployeeId}`,
            },
            {
              menuValue: "Leaves",
              route: `/leaves-employee/${loginEmployeeId}`,
            },
            {
              menuValue: "Attendance",
              route: `/attendance-employee/${loginEmployeeId}`,
            },
            {
              menuValue: "Task Box",
              route: `/taskbox/${loginEmployeeId}`,
            },
            {
              menuValue: "Reimbursement",
              route: `/reimbursement/${loginEmployeeId}`,
            },
            {
              menuValue: "Performance Bonus",
              route: `/performance-bonus/${loginEmployeeId}`,
            },
            {
              menuValue: "My Policies",
              route: "/my-policies",
            },
            {
              menuValue: "My Document",
              route: `/my-document/${loginEmployeeId}`,
            },
            {
              menuValue: "My Pay",
              route: `/mypay/${loginEmployeeId}`,
            },
            {
              menuValue: "Assigned Asset",
              route: `/assigned-asset/${loginEmployeeId}`,
            },
            {
              menuValue: "Goal List",
              route: "/goal-list",
              accessTo: ["Admin", "HR", "Employee"],
            },
          ],
        },
      ],
    },
    {
      tittle: "EMPLOYEES",
      showAsTab: false,
      separateRoute: false,
      menu: [
        {
          menuValue: "Employees",
          hasSubRoute: true,
          showSubRoute: false,
          route: "#",
          icon: "la la-users",
          subMenus: [
            {
              menuValue: "Onboarding Status",
              route: `/employee-onboarding-list`,
              accessTo: ["Admin", "HR"],
            },
            {
              menuValue: "All Employees",
              route: "/employees",
              accessTo: ["Admin", "HR"],
            },
            {
              menuValue: "Daily Task",
              route: "/create-task",
              accessTo: ["Admin", "HR"],
            },
            {
              menuValue: "Attendance",
              route: "/adminattendance",
              accessTo: ["Admin", "HR"],
            },
            {
              menuValue: "Separation",
              route: "/employees-resignation",
            },
            {
              menuValue: "FNF",
              route: "/employee-fnf",
              accessTo: ["Admin", "HR"],
            },
            {
              menuValue: "Goals Setting",
              route: "/goal-setting",
              accessTo: ["Admin", "HR"],
            },
            {
              menuValue: "Performance Appraisal",
              route: "/performance-appraisal",
              accessTo: ["Admin", "Employee", "HR"],
            },
            {
              menuValue: "Performance Review",
              route: "/performance-review",
              accessTo: ["Admin", "HR", "Employee"],
            },
            {
              menuValue: "Asset assignment",
              hasSubRoute: false,
              showSubRoute: false,
              accessTo: ["Admin", "HR"],
              route: "/asset-assignment",
              icon: "la la-box",
            },
            {
              menuValue: "Salary",
              hasSubRoute: false,
              showSubRoute: false,
              accessTo: ["Admin", "HR"],
              route: "/employees-salary",
              icon: "la la-receipt",
            },
            {
              menuValue: "Work Status",
              hasSubRoute: false,
              showSubRoute: false,
              accessTo: ["HR", "Admin"],
              route: "/employee-work-status",
              icon: "la la-tasks",
            },
            {
              menuValue: "Documents",
              hasSubRoute: false,
              showSubRoute: false,
              accessTo: ["HR", "Admin"],
              route: "/upload-document",
              icon: "la la-file-text",
            },
            {
              menuValue: "PIP",
              route: "/pip",
              accessTo: ["Admin", "HR"],
            },
          ],
        },
      ],
    },
    {
      tittle: "Company",
      showAsTab: false,
      separateRoute: false,
      accessTo: ["Admin"],
      menu: [
        {
          menuValue: "Company",
          hasSubRoute: true,
          showSubRoute: false,
          route: "#",
          icon: "la la-building",
          subMenus: [
            {
              menuValue: "Subscription",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/subscription-detail",
              icon: "la la-building",
            },
            {
              menuValue: "Departments",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/departments",
              accessTo: ["Admin", "HR"],
              icon: "la la-building",
            },
            {
              menuValue: "Designations",
              hasSubRoute: false,
              showSubRoute: false,
              route: "/designations",
              accessTo: ["Admin", "HR"],
              icon: "la la-id-badge",
            },
            {
              menuValue: "Leaves Configuration",
              hasSubRoute: false,
              showSubRoute: false,
              accessTo: ["HR", "Admin"],
              route: "/company-leave",
              icon: "la la-calendar-check",
            },

            {
              menuValue: "Policies",
              hasSubRoute: false,
              showSubRoute: false,
              accessTo: ["HR", "Admin"],
              route: "/policies",
              icon: "la la-file-pdf-o",
            },
          ],
        },
      ],
    },
    {
      tittle: "CRM",
      showAsTab: false,
      separateRoute: false,
      accessTo: ["Admin"],
      menu: [
        ...(companyId == 1
          ? [
              {
                menuValue: "Companies",
                hasSubRoute: false,
                showSubRoute: false,
                route: "/companies",
                accessTo: ["Admin"],
                icon: "la la-building",
              },
              {
                menuValue: "Campaign",
                hasSubRoute: false,
                showSubRoute: false,
                route: "/send-mail-for-campaign",
                accessTo: ["Admin"],
                icon: "la la-envelope",
              },
            ]
          : []),
      ],
    },
  ];

  let SidebarData;
  if (!onboardingStatus) {
    SidebarData = [];
  } else if (onboardingStatus === "COMPLETED") {
    SidebarData = allMenus;
  } else if (onboardingStatus === "PENDING") {
    SidebarData = onboardingPending;
  } else {
    SidebarData = [];
  }
  return SidebarData;
};
